<template>
  <div class="job-list" v-loading="loadingData">
    <basic-table
      :table-data="jobsPage"
      :table-headers="tableHeaders"
      :has-actions="true"
      :sortChange="sortChange"
      :paginationChange="paginationChange"
    >
      <template v-slot:row-actions="props">
        <slot name="actions" v-bind:row="props.row" v-bind:index="props.index">
          <el-button type="text" @click="goToJobDetail(props.row.no)">
            Detail
          </el-button>
        </slot>
      </template>
      <template v-slot:footer-ops>
        <el-button type="primary" plain size="mini" @click="refreshPage">
          Refresh
        </el-button>
      </template>
    </basic-table>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
// models
import { JobTableHeaders } from '@/core/models/job'
// components
import BasicTable from '@/components/common/BasicTable.vue'
// mixins
import { pageJumps } from '@/core/mixin/pages'
import {
  Ascending,
  Descending,
  getDefaultSort,
  PageCurrentKey,
  PageSizeKey
} from '@/core/configs/types'
import { queryJobs } from '@/api/job'
export default {
  name: 'JobList',
  components: {
    BasicTable
  },
  mixins: [pageJumps],
  props: {
    jobQuery: {
      type: Object,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    },
    tableHeaders: {
      type: Array,
      default: () => JobTableHeaders
    }
  },
  data() {
    return {
      jobList: null,
      pagination: {
        [PageSizeKey]: 100,
        [PageCurrentKey]: 1,
        total: 0,
        asc: '',
        desc: ''
      },
      loadingData: false,
      debouncedQuery: debounce(this.fetchJobs, 300)
    }
  },
  computed: {
    jobsPage() {
      return {
        records: this.jobList,
        ...this.pagination
      }
    }
  },
  methods: {
    refreshPage() {
      this.debouncedQuery()
    },
    sortChange(sort) {
      if (sort.order === Ascending) {
        this.pagination.asc = sort.col
        this.pagination.desc = ''
      } else if (sort.order === Descending) {
        this.pagination.desc = sort.col
        this.pagination.asc = ''
      }
      this.debouncedQuery()
    },
    paginationChange(key, path, value) {
      this.pagination[key] = value
      this.debouncedQuery()
    },
    async fetchJobs() {
      this.loadingData = true
      getDefaultSort(JobTableHeaders, this.pagination)
      let page
      if (!isEmpty(this.jobQuery)) {
        page = await queryJobs({ ...this.jobQuery, ...this.pagination })
      }
      this.$set(this, 'jobList', page?.records ?? [])
      this.pagination.total = page?.total ?? 0
      this.loadingData = false
    }
  },
  watch: {
    refresh: {
      handler() {
        this.debouncedQuery()
      },
      immediate: true
    },
    jobQuery: {
      handler(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) return
        this.debouncedQuery()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
